<div class="row">
  <div class="col-md-12">
    <div
      class="col-md-12 text-center"
      *ngIf="
        data.statusType === 'PRE_AUTH_UNDER_QUERY' ||
        data.statusType === 'ENHANCEMENT_UNDER_QUERY' ||
        data.statusType === 'FINAL_BILLS_UNDER_QUERY' ||
        data.statusType === 'QUERY' ||
        data.statusType === 'FILE_SUBMITTED_UNDER_QUERY'
      "
    >
      <span class="MM30">Raise Query</span>
      <span mat-dialog-close matSuffix style="float: right">
        <mat-icon>close</mat-icon>
      </span>
      <p class="MM18">
        Upload relevant documents and add a comment to submit a response
      </p>
    </div>
    <div
      class="col-md-12 text-center"
      *ngIf="
        data.statusType === 'PRE_AUTH_QUERY_RESPONDED' ||
        data.statusType === 'ENHANCEMENT_QUERY_RESPONDED' ||
        data.statusType === 'FINAL_BILLS_QUERY_RESPONDED' ||
        data.statusType === 'FILE_SUBMITTED_QUERY_RESPONDED'
      "
    >
      <span class="MM30">Respond To Query</span>
      <span mat-dialog-close matSuffix style="float: right">
        <mat-icon>close</mat-icon>
      </span>
    </div>
    <div
      class="col-md-12 text-center"
      *ngIf="data.statusType === 'PRE_APPROVAL_RECEIVED'"
    >
      <span class="MM30">Pre-Approval Received</span>
      <span mat-dialog-close matSuffix style="float: right">
        <mat-icon>close</mat-icon>
      </span>
      <p class="MM18">
        Upload relevant documents and add a comment to submit a response
      </p>
    </div>
    <div
      class="col-md-12 text-center"
      *ngIf="data.statusType === 'ENHANCEMENT_APPROVAL_RECEIVED'"
    >
      <span class="MM30">Enhancement Approval Received</span>
      <span mat-dialog-close matSuffix style="float: right">
        <mat-icon>close</mat-icon>
      </span>
      <p class="MM18">
        Upload relevant documents and add a comment to submit a response
      </p>
    </div>
    <div class="col-md-12 text-center" *ngIf="data.statusType === 'DISCHARGE'">
      <span class="MM30">Discharge</span>
      <span mat-dialog-close matSuffix style="float: right">
        <mat-icon>close</mat-icon>
      </span>
      <p class="MM18">
        Upload relevant documents and add a comment to submit a response
      </p>
    </div>
    <div class="col-md-12 text-center" *ngIf="data.statusType === 'APPROVE'">
      <span class="MM30">APPROVE</span>
      <span mat-dialog-close matSuffix style="float: right">
        <mat-icon>close</mat-icon>
      </span>
      <p class="MM18">
        Upload relevant documents and add a comment to submit a response
      </p>
    </div>
    <div class="col-md-12 text-center" *ngIf="data.statusType === 'REJECT'">
      <span class="MM30">Reject Claim</span>
      <span mat-dialog-close matSuffix style="float: right">
        <mat-icon>close</mat-icon>
      </span>
      <p class="MM18">
        Upload relevant documents and add a comment to submit a response
      </p>
    </div>
    <div class="col-md-12 text-center" *ngIf="data.statusType === 'SETTLED'">
      <span class="MM30">Settle Claim</span>
      <span mat-dialog-close matSuffix style="float: right">
        <mat-icon>close</mat-icon>
      </span>
      <p class="MM18">
        Upload relevant documents and add a comment to submit a response
      </p>
    </div>
  </div>
</div>
<div class="content">
  <!--Respond to Query-->
  <ng-template
    [ngIf]="
      data.statusType === 'PRE_AUTH_UNDER_QUERY' ||
      data.statusType === 'ENHANCEMENT_UNDER_QUERY' ||
      data.statusType === 'QUERY' ||
      data.statusType == 'FINAL_BILLS_UNDER_QUERY' ||
      data.statusType === 'FILE_SUBMITTED_UNDER_QUERY'
    "
  >
    <!--Query Remarks-->
    <div class="row row_flex">
      <!--        
      <div class="col-md-12">
        <div class="form-group">
          <label class="MM18">Query Remarks</label>
          <textarea class="form-control" rows="4"> </textarea>
        </div>
      </div> -->

      <!--Query Date/Time-->
      <div class="col-md-3">
        <div class="row">
          <div class="col-md-12">
            <label class="MM18">Date & Time of Query</label>
          </div>
          <div class="col-md-12">
            <div class="form-group whitespace_fix edit_calender_sec">
              <mat-form-field class="example-full-width" color="accent">
                <mat-label class="label-flex">Date - Time</mat-label>
                <input
                  matInput
                  [ngxMatDatetimePicker]="picker"
                  placeholder="Choose a date"
                  [readonly]="true"
                  [(ngModel)]="claimQuery.$timestamp"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="$any(picker)"
                ></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #picker> </ngx-mat-datetime-picker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="MM18">Upload Query Letter</label>
          </div>
          <div class="col-md-12">
            <div id="upload_button">
              <label class="save_btn, save_accent" style="padding: 0.4rem">
                <a color="primary">Choose File</a>
                <input
                  type="file"
                  (change)="addQueryDocument($event)"
                  accept=".jpg, .jpeg, .pdf, .tiff"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <ngx-extended-pdf-viewer
          [src]="thispreviewimageUrl"
          backgroundColor="#ffffff"
          [height]="'90vh'"
          [useBrowserLocale]="true"
          [handTool]="false"
          [showHandToolButton]="true"
        >
        </ngx-extended-pdf-viewer>
      </div>
      <!--Upload Query Letter-->
    </div>
    <!--Query Response & Document List-->
    <div class="row row_flex">
      <!--Query Response-->
      <div class="col-md-6">
        <!-- <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <label class="MM18"
                  >Would you like to respond to the Query raised?</label
                >
              </div>
              <div class="col-md-12">
                <mat-radio-group [(ngModel)]="queryResponse" class="pl-2 pt-2">
                  <mat-radio-button
                    class="radio-margin mr-3 MM14"
                    [value]='true'
                    >Yes</mat-radio-button
                  >
                  <mat-radio-button
                    class="radio-margin noRadio MM14"
                    [value]="false"
                    >No</mat-radio-button
                  >
                </mat-radio-group>
              </div>
            </div>
          </div>
          <div class="col-md-12" *ngIf="queryResponse">
            <div class="form-group">
              <label class="MM18">Query Response</label>
              <p class="MM16" style="color: #013cdb">
                Enter a response to submit for the query raised
              </p>
              <textarea [(ngModel)]="queryNotes"
                class="form-control"
                placeholder="Add a response for the query here"
                rows="6"
              >
              </textarea>
            </div>
            <button
              type="button"
              class="floatingButton"
              mat-stroked-button
              (click)="uploadDocumentModal()"
            >
              <div class="row m-0 p-0">
                <div
                  class="
                    col-12
                    pl-0
                    pr-0
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                >
                  <mat-icon>folder_open</mat-icon>
                  <p class="pl-2 pr-2 m-0 MM14">Documents</p>
                </div>
              </div>
            </button>
          </div>
        </div> -->
      </div>
      <!--Documents Tag and Viewer-->
    </div>
    <!--Submit Button-->
    <!-- <div class="row row_flex">
      <div class="col-md-12">
        <button
          mat-stroked-button
          color="primary"
          class="buttonSmallPrimaryBlue"
        >
          Submit
        </button>
      </div>
    </div> -->
  </ng-template>

  <!--Respond to Query-->
  <ng-template
    [ngIf]="
      data.statusType === 'PRE_AUTH_QUERY_RESPONDED' ||
      data.statusType === 'ENHANCEMENT_QUERY_RESPONDED' ||
      data.statusType === 'FINAL_BILLS_QUERY_RESPONDED' ||
      data.statusType === 'FILE_SUBMITTED_QUERY_RESPONDED'
    "
  >
    <!--Query Remarks-->
    <div class="row row_flex">
      <!--Query Date/Time-->
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <label class="MM18">Date & Time of Query</label>
          </div>
          <!-- <div class="col-md-6">{{ timeStamp | date: "medium":"UTC" }} -->
          <div class="col-md-6">
            {{ timeStamp | date: "medium":"IST" }}
            <!-- <div class="form-group whitespace_fix edit_calender_sec">
              <mat-form-field class="example-full-width" color="accent">
                
                <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date" [(ngModel)]="claimQuery.$timestamp" >
                <mat-datepicker-toggle matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #picker>
                </ngx-mat-datetime-picker>
             </mat-form-field>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!--Query Response & Document List-->
    <div class="row row_flex">
      <!--Query Response-->
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="MM18">Query Response</label>
              <p class="MM16" style="color: #013cdb">
                Enter a response to submit for the query raised
              </p>
              <textarea
                [(ngModel)]="queryNotes"
                class="form-control"
                placeholder="Add a response for the query here"
                rows="6"
              >
              </textarea>
            </div>
            <div class="col">
              <button
                type="button"
                class="floatingButton"
                mat-stroked-button
                (click)="uploadDocumentModal()"
              >
                <div class="row m-0 p-0">
                  <div
                    class="col-12 pl-0 pr-0 d-flex justify-content-center align-items-center"
                  >
                    <mat-icon>folder_open</mat-icon>
                    <p class="pl-2 pr-2 m-0 MM14">Documents</p>
                  </div>
                  <div
                    *ngIf="totalDocument > 0"
                    class="col-12"
                    style="
                      border-color: #42deb1;
                      text-align: center;
                      border-width: 1px;
                      border-style: solid;
                      padding: 2%;
                      border-left: 0px;
                      border-bottom: 0px;
                      border-right: 0px;
                      color: #013cdb;
                    "
                  >
                    <ng-template [ngIf]="totalDocument === 1">
                      <span class="MM16"> {{ totalDocument }} File </span>
                    </ng-template>
                    <ng-template [ngIf]="totalDocument > 1">
                      <span class="MM16"> {{ totalDocument }} Files </span>
                    </ng-template>
                  </div>
                  <div
                    *ngIf="totalDocument === 0"
                    class="col-12"
                    style="
                      border-color: black;
                      text-align: center;
                      border-width: 1px;
                      border-style: solid;
                      color: #013cdb;
                      padding: 2%;
                      border-left: 0px;
                      border-bottom: 0px;
                      border-right: 0px;
                    "
                  >
                    0 Files
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <ngx-extended-pdf-viewer
          [base64Src]="queryLetter"
          backgroundColor="#ffffff"
          [height]="'90vh'"
          [useBrowserLocale]="true"
          [handTool]="false"
          [showHandToolButton]="true"
        >
        </ngx-extended-pdf-viewer>
      </div>
    </div>
    <!--Submit Button-->
    <!-- <div class="row row_flex">
      <div class="col-md-12">
        <button
          mat-stroked-button
          color="primary"
          class="buttonSmallPrimaryBlue"
        >
          Submit
        </button>
      </div>
    </div> -->
  </ng-template>

  <ng-template [ngIf]="data.statusType === 'DISCHARGE'">
    <div class="row row-flex" style="margin-top: 2rem">
      <div class="col-md-2 col-sm-12">
        <div class="form-group">
          <mat-form-field class="example-full-width">
            <mat-label class="label-flex">Actual Admission Date</mat-label>
            <input
              matInput
              [matDatepicker]="admissionDate" 
              [readonly]="true"
              (dateInput)="admissionChange($event.value)"
              [(ngModel)]="
                data.claimDetails.claimDetails.policyStatus.policyValidity
                  .admissionDate
              "
              [ngModelOptions]="{ standalone: true }"
            />

            <mat-datepicker-toggle matSuffix [for]="admissionDate">
            </mat-datepicker-toggle>
            <mat-datepicker #admissionDate> </mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-2 col-sm-12">
        <div class="form-group">
          <mat-form-field class="example-full-width">
            <input
              matInput
              [matDatepicker]="dischargeDate"
              (dateInput)="dischargeChange($event.value)"
              placeholder="Actual Discharge Date" 
              [readonly]="true"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="
                data.claimDetails.claimDetails.policyStatus.policyValidity
                  .dischargeDate
              "
              [min]="
                data.claimDetails.claimDetails.policyStatus.policyValidity
                  .admissionDate
              "
            />

            <mat-datepicker-toggle matSuffix [for]="dischargeDate">
            </mat-datepicker-toggle>
            <mat-datepicker #dischargeDate> </mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-2 col-sm-12">
        <div class="form-group">
          <mat-form-field class="example-full-width">
            <input
              type="time"
              matInput="matInput"
              placeholder="Discharge Time"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="
                data.claimDetails.claimDetails.policyStatus.policyValidity
                  .dischargeTime
              "
            />
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <mat-form-field class="example-full-width">
            <mat-label class="label-flex">Total Amount</mat-label>
            <input
              matInput
              [(ngModel)]="data.claimDetails.invoiceDetails.totalInvoiceAmount"
            />
            <span matPrefix class="mr-3">
              <label>₹</label>
            </span>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-3 col-sm-12">
        <button
          type="button"
          class="floatingButton"
          mat-stroked-button
          (click)="uploadDocumentModal()"
        >
          <div class="row m-0 p-0">
            <div
              class="col-12 pl-0 pr-0 d-flex justify-content-center align-items-center"
            >
              <mat-icon>folder_open</mat-icon>
              <p class="pl-2 pr-2 m-0">Documents</p>
            </div>
            <div
              *ngIf="totalDocument > 0"
              class="col-12"
              style="
                border-color: #42deb1;
                text-align: center;
                border-width: 1px;
                border-style: solid;
                padding: 2%;
                border-left: 0px;
                border-bottom: 0px;
                border-right: 0px;
                color: #013cdb;
              "
            >
              <ng-template [ngIf]="totalDocument === 1">
                {{ totalDocument }} File
              </ng-template>
              <ng-template [ngIf]="totalDocument > 1">
                {{ totalDocument }} Files
              </ng-template>
            </div>
            <div
              *ngIf="totalDocument === 0"
              class="col-12"
              style="
                border-color: black;
                text-align: center;
                border-width: 1px;
                border-style: solid;
                color: #013cdb;
                padding: 2%;
                border-left: 0px;
                border-bottom: 0px;
                border-right: 0px;
              "
            >
              0 Files
            </div>
          </div>
        </button>
      </div>
    </div>
    <div class="row row_flex" style="min-height: 40vh">
      <div class="col-md-12">
        <div class="row">
          <div class="col-12">
            <div class="mt-5 container">
              <div class="row mb-3">
                <div class="col-md-12">
                  <span class="MM18">Payment Summary</span>
                  <p>
                    Detailed breakup of claim amount calculation will be as per
                    the letter of credit issue by the TPA.
                  </p>
                </div>
              </div>
              <table
                class="table table-bordered MM14"
                style="table-layout: fixed"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th scope="col">Total Claimed</th>
                    <th scope="col">Deductions</th>
                    <th scope="col">Total Approved</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngIf="
                      data.claimDetails.claimAmount?.insurerPaymentSummary
                        ?.preAuthApproval
                    "
                  >
                    <td>Pre Auth Approval</td>
                    <td style="text-align: right">
                      {{
                        data.claimDetails.claimAmount?.insurerPaymentSummary
                          .preAuthApproval.claimedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td
                      style="text-align: right"
                      class="text-right"
                      *ngIf="
                        [
                          'PRE_AUTH_SUBMITTED',
                          'PRE_AUTH_UNDER_REVIEW',
                          'PRE_AUTH_UNDER_QUERY',
                          'PRE_AUTH_QUERY_RESPONDED',
                          'CLAIM_REJECTED'
                        ].indexOf(data.claimDetails.claimStatus) === -1
                      "
                    >
                      {{
                        data.claimDetails.claimAmount?.insurerPaymentSummary
                          .preAuthApproval.deductions
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td
                      style="text-align: right"
                      class="text-right"
                      *ngIf="
                        [
                          'PRE_AUTH_SUBMITTED',
                          'PRE_AUTH_UNDER_REVIEW',
                          'PRE_AUTH_UNDER_QUERY',
                          'PRE_AUTH_QUERY_RESPONDED',
                          'CLAIM_REJECTED'
                        ].indexOf(data.claimDetails.claimStatus) != -1
                      "
                    >
                      {{ zeroAmount | currency: "INR":"symbol":"1.0-0" }}
                    </td>

                    <td
                      style="text-align: right"
                      class="text-right"
                      *ngIf="
                        [
                          'PRE_AUTH_SUBMITTED',
                          'PRE_AUTH_UNDER_REVIEW',
                          'PRE_AUTH_UNDER_QUERY',
                          'PRE_AUTH_QUERY_RESPONDED',
                          'CLAIM_REJECTED'
                        ].indexOf(data.claimDetails.claimStatus) === -1
                      "
                    >
                      {{
                        data.claimDetails.claimAmount?.insurerPaymentSummary
                          .preAuthApproval.finalApprovedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td
                      style="text-align: right"
                      class="text-right"
                      class="text-right"
                      *ngIf="
                        [
                          'PRE_AUTH_SUBMITTED',
                          'PRE_AUTH_UNDER_REVIEW',
                          'PRE_AUTH_UNDER_QUERY',
                          'PRE_AUTH_QUERY_RESPONDED',
                          'CLAIM_REJECTED'
                        ].indexOf(data.claimDetails.claimStatus) != -1
                      "
                    >
                      {{ zeroAmount | currency: "INR":"symbol":"1.0-0" }}
                    </td>
                  </tr>
                  <ng-template
                    [ngIf]="
                      data.claimDetails?.claimAmount?.insurerPaymentSummary
                        ?.enhancementApprovals
                    "
                  >
                    <tr
                      *ngFor="
                        let item of data.claimDetails?.claimAmount
                          ?.insurerPaymentSummary?.enhancementApprovals;
                        let i = index
                      "
                    >
                      <td>Enhancement {{ i + 1 }}</td>
                      <td style="text-align: right">
                        {{
                          item.claimedAmount | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>
                      <td style="text-align: right">
                        {{ item.deductions | currency: "INR":"symbol":"1.0-0" }}
                      </td>

                      <td style="text-align: right">
                        {{
                          item.finalApprovedAmount
                            | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>
                    </tr>
                  </ng-template>
                  <tr
                    *ngIf="
                      data.claimDetails?.claimAmount?.insurerPaymentSummary
                        ?.finalApproval
                    "
                  >
                    <td>Final Approval</td>

                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.finalApproval.claimedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.finalApproval.deductions
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>

                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.finalApproval.finalApprovedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      data.claimDetails?.claimAmount?.insurerPaymentSummary
                        ?.revisedFinalApproval
                    "
                  >
                    <td>Revised Final Approval</td>
                    <ng-template
                      [ngIf]="
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.revisedFinalApproval
                      "
                    >
                      <td style="text-align: right">
                        {{
                          data.claimDetails?.claimAmount?.insurerPaymentSummary
                            ?.revisedFinalApproval.claimedAmount
                            | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>
                      <td style="text-align: right">
                        {{
                          data.claimDetails?.claimAmount?.insurerPaymentSummary
                            ?.revisedFinalApproval.deductions
                            | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>

                      <td style="text-align: right">
                        {{
                          data.claimDetails?.claimAmount?.insurerPaymentSummary
                            ?.revisedFinalApproval.finalApprovedAmount
                            | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>
                    </ng-template>
                  </tr>
                  <tr
                    *ngIf="
                      data.claimDetails?.claimAmount?.insurerPaymentSummary
                        ?.reimbursementApproval
                    "
                  >
                    <td>Reimbursement Approval</td>
                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.reimbursementApproval.claimedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.reimbursementApproval.deductions
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>

                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.reimbursementApproval.finalApprovedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--Upload NOC-->
        </div>
      </div>
      <!-- <div class="col-md-5" *ngIf="thispreviewimageUrl">
        <ngx-extended-pdf-viewer [src]="thispreviewimageUrl" backgroundColor="#ffffff" [height]="'90vh'"
          [useBrowserLocale]="true" [handTool]="false" [showHandToolButton]="true">
        </ngx-extended-pdf-viewer>
      </div> -->
    </div>
  </ng-template>
 
  <!--Approval Recieved-->
  <ng-template
    [ngIf]="
      data.statusType === 'PRE_APPROVAL_RECEIVED' ||
      data.statusType === 'ENHANCEMENT_APPROVAL_RECEIVED' ||
      data.statusType === 'APPROVE'
    "
  >
    <div class="row row_flex" style="min-height: 40vh">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12 col_flex">
            <div class="row">
              <div class="col-md-12">
                <label class="MM18">Invoice Details</label>
              </div>
            </div>
            <div class="card card_fill box-shadow">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <mat-form-field class="example-full-width">
                      <mat-label class="label-flex">Requested Amount</mat-label>
                      <input matInput [(ngModel)]="data.claimDetails.invoiceDetails.totalInvoiceAmount" disabled/>
                      <span matPrefix class="mr-3">
                        <label>₹</label>
                      </span>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <mat-form-field class="example-full-width">
                      <mat-label class="label-flex"
                        >Authorised Amount</mat-label
                      >
                      <input
                        matInput
                        (keyup)="getSum()"
                        [(ngModel)]="
                          data.claimDetails.invoiceDetails.totalApprovedAmount
                        "
                      />
                      <span matPrefix class="mr-3">
                        <label>₹</label>
                      </span>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <mat-form-field class="example-full-width">
                      <mat-label class="label-flex"
                        >Disapproved Amount</mat-label
                      >
                      <input
                        type="number"
                        min="0"
                        matInput
                        [(ngModel)]="
                          data.claimDetails.invoiceDetails
                            .totalNonClaimableAmount
                        "
                        disabled
                      />
                      <span matPrefix class="mr-3">
                        <label>₹</label>
                      </span>
                    </mat-form-field>
                  </div>
                </div>
                <p style="color: red;margin: 1rem;" *ngIf="data.claimDetails.invoiceDetails
                .totalNonClaimableAmount < 0">Approval amount can not be greater than the claimed amount.</p>
               
              </div>
            </div>
          </div>
          <!--Upload NOC-->
          <div class="col-md-12 col_flex">
            <div class="row">
              <div class="col-md-12">
                <label>Upload LOC Document</label>
              </div>
            </div>
            <div class="col-md-12">
              <div id="upload_button">
                <label class="save_btn, save_accent" style="padding: 0.4rem">
                  <a color="primary">Choose File</a>
                  <input
                    multiple
                    type="file"
                    accept=".jpg, .jpeg, .pdf, .tiff"
                    (change)="addDocumentE($event)"
                  />
                </label>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-12 col_flex">
            <button mat-raised-button color="primary" class="save_secondary">
              Upload
            </button>
          </div> -->
          <!--Invoice Details-->

          <!--Bill Disallowed-->
          <!-- <div class="col-md-12 col_flex">
            <div class="row">
              <div class="col-md-12">
                <label>Is Bill Disallowed</label>
              </div>
              <div class="col-md-12">
                <mat-radio-group class="pl-2 pt-2">
                  <mat-radio-button
                    class="radio-margin mr-3 MM14"
                    [value]="true"
                    >Yes</mat-radio-button
                  >
                  <mat-radio-button
                    class="radio-margin noRadio MM14"
                    [value]="false"
                    >No</mat-radio-button
                  >
                </mat-radio-group>
              </div>
            </div>
          </div>
          <div class="col-md-12 col_flex">
            <mat-form-field
              class="example-full-width greenBorder MSB16"
              floatLabel="never"
            >
              <mat-select placeholder="Select a reason">
                <mat-option class="MM16"> Option 1 </mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->
          <!--Disallowed Reason-->
          <!-- <div class="col-md-12 col_flex">
            <textarea
              class="form-control"
              placeholder="Add a reason for disallowing"
              rows="4"
            >
            </textarea>
          </div> -->
          <!--Submit Btn-->
          <!-- <div class="col-md-12 col_flex">
            <button
              mat-stroked-button
              color="primary"
              class="buttonSmallPrimaryBlue"
            >
              Submit
            </button>
          </div> -->
        </div>
      </div>
      <div class="col-md-6" *ngIf="thispreviewimageUrl">
        <ngx-extended-pdf-viewer
          [src]="thispreviewimageUrl"
          backgroundColor="#ffffff"
          [height]="'90vh'"
          [useBrowserLocale]="true"
          [handTool]="false"
          [showHandToolButton]="true"
        >
        </ngx-extended-pdf-viewer>
      </div>
      <div class="col-md-12">
        <p style="color: red;">*For Detailed breakup of claim amount calculation will be as per the letter of credit issue by the TPA.</p>
      </div>
    </div>
  </ng-template>
  <!--Rejected-->
  
  <ng-template [ngIf]="data.statusType === 'REJECT'">
    <div class="row row_flex">
      <div class="col-md-12">
        <div class="row">
          <!--Reject Reason Reason-->
          <div class="col-md-12 col_flex">
            <textarea
              class="form-control"
              placeholder="Add a reason "
              rows="4"
              [(ngModel)]="rejectReason"
            >
            </textarea>
          </div>
          <!--Submit Btn-->
        </div>
      </div>
      <!--Upload NOC-->
      <div class="col-md-12 col_flex">
        <!-- <div class="row">
          <div class="col-md-12">
            <label>Reject Claim</label>
          </div>
        </div> -->
        <label>Upload Rejection Letter</label>
        <div class="col-md-12">
          <div id="upload_button">
            <label class="save_btn, save_accent" style="padding: 0.4rem">
              <a color="primary">Choose File</a>
              <input
                multiple
                type="file"
                accept=".jpg, .jpeg, .pdf, .tiff"
                (change)="addDocumentE($event)"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <ngx-extended-pdf-viewer
          [src]="thispreviewimageUrl"
          backgroundColor="#ffffff"
          [height]="'90vh'"
          [useBrowserLocale]="true"
          [handTool]="false"
          [showHandToolButton]="true"
        >
        </ngx-extended-pdf-viewer>
      </div>
    </div>
  </ng-template>
  <!--SETTLED-->
  <ng-template
    [ngIf]="data.statusType === 'SETTLED'"
    [formGroup]="settlementForm"
  >
    <div class="row row_flex">
      <div class="col-md-3">
        <div class="form-group">
          <mat-form-field class="example-full-width">
            <mat-label class="label-flex"
              >Settlement Type <span class="text-danger">*</span></mat-label
            >
            <mat-select formControlName="settlementType">
              <mat-option class="MM16" value="SETTLED"> Settlement </mat-option>
              <mat-option class="MM16" value="PARTIALLY_SETTLED">
                Partial Settlement
              </mat-option>
            </mat-select>
            <!-- <input matInput /> -->
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <mat-form-field class="example-full-width">
            <mat-label class="label-flex"
              >Approved Amount <span class="text-danger">*</span></mat-label
            >
            <input matInput formControlName="approvedAmount" readonly  />
            <span matPrefix class="mr-3">
              <label>₹</label>
            </span>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div formArrayName="settlementGroups">
      <div *ngFor="let item of getControls(); let i = index" class="backgroundWhiteBorder p-2 mt-2">
      <div class="row row_flex" [formGroupName]="i" >
      
        <div class="col-md-3">
          <div class="form-group">
            <mat-form-field class="example-full-width">
              <mat-label class="label-flex"
                >Paid Amount <span class="text-danger">*</span></mat-label
              >
              <input matInput formControlName="paidAmount" />
              <span matPrefix class="mr-3">
                <label>₹</label>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <mat-form-field class="example-full-width">
              <mat-label class="label-flex"
                >TDS Amount <span class="text-danger">*</span></mat-label
              >
              <input matInput formControlName="tdsAmount" />
              <span matPrefix class="mr-3">
                <label>₹</label>
              </span>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <mat-form-field class="example-full-width">
              <mat-label class="label-flex"
                >UTR No. <span class="text-danger">*</span></mat-label
              >
              <input matInput maxlength="20" formControlName="utrNo" />
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <mat-form-field class="example-full-width">
              <mat-label class="label-flex"
                >Payment Date <span class="text-danger">*</span></mat-label
              >
              <input
                matInput
                formControlName="paymentDate"
                [readonly]="true"
                [matDatepicker]="paymentpicker"
                [min] ="dischargeDate"
                [max] =  "maxDate"
                
              />
              <mat-datepicker-toggle matSuffix [for]="paymentpicker">
              </mat-datepicker-toggle>
              <mat-datepicker #paymentpicker> </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-10">
          <div class="form-group">
            <mat-form-field class="example-full-width">
              <mat-label class="label-flex"
                >Comments <span class="text-danger">*</span></mat-label
              >
              <textarea
                matInput
                class="form-control"
                formControlName="commentBox"
                rows="3"
              >
              </textarea>
              <!-- <div class="d-block invalid-feedback"
                *ngIf="item.controls.commentBox?.errors.required">
                Vial is must be numeric</div> -->
            </mat-form-field>
          </div>       
        </div>
       <div class="col-md-2" *ngIf="i > 0">
         
          <button class="mat-focus-indicator mat-raised-button mat-button-base mat-warn ng-star-inserted" style="margin: 2%; width: 100%;" (click)="masterRemoveItem(i)">Remove</button>
        </div>
      </div>
    </div> 
    </div> 
    <div class="row row_flex">
      <div class="col-md-2">
        <button class="mat-focus-indicator mat-raised-button mat-button-base mat-accent ng-star-inserted" style="margin: 2%; width: 100%;" (click)="masterAddItem()">Add</button>
      </div>
    </div>
    <!--Upload Settlement Letter-->
    <div class="row row_flex">
      <!--Upload NOC-->
      <div class="col-md-12 col_flex">
        <!-- <div class="row">
          <div class="col-md-12">
            <label>Reject Claim</label>
          </div>
        </div> -->
        <label class="MM16 font-weight-bold">
          Upload Settlement Letter<span class="text-danger">*</span>
          </label>
      </div>
      <div class="col-md-12">
        <div id="upload_button">
          <label class="save_btn, save_accent" style="padding: 0.4rem">
            <a color="primary">Choose File</a>
            <input
              multiple
              type="file"
              accept=".jpg, .jpeg, .pdf, .tiff"
              (change)="addSettledDocument($event)"
            />
          </label>
        </div>
      </div>
    </div>
    <!--Letter Viewer-->
    <div class="row row_flex">
      <div class="col-md-12">
        <div *ngIf="documents">
          <table
                class="table table-bordered MM14"
                style="table-layout: fixed"
              >
                <thead>
                  <tr>
                    <th> Name</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of documents; index as i">
                    <td>{{ item.name }} </td>
                    <td>
                      <mat-icon color="primary" style="cursor: pointer" (click)="showFile(item.file)">
                        remove_red_eye</mat-icon>{{ item.documentType }}
                        <button class="mat-focus-indicator mat-raised-button mat-button-base mat-warn ng-star-inserted" (click)="deleteDocument(i)">Delete</button>
                    </td>
                  </tr>
                </tbody>                
            </table>
        </div>
        </div>
      </div>
    <!-- <div class="row row_flex">
      <div class="col-md-12" *ngIf="thispreviewimageUrl">
        <ngx-extended-pdf-viewer
          [src]="thispreviewimageUrl"
          backgroundColor="#ffffff"
          [height]="'90vh'"
          [useBrowserLocale]="true"
          [handTool]="false"
          [showHandToolButton]="true"
        >
        </ngx-extended-pdf-viewer>
      </div>
    </div> -->
    <div class="col-md-12">
      <p style="color: red;">*For Detailed breakup of claim amount calculation will be as per the letter of credit issue by the TPA.</p>
    </div>

  <ng-template [ngIf]="data.statusType === 'SETTLED' && data.claimDetails?.listOfPaymentDetails">
    <div class="row row_flex" style="min-height: 20vh">
      <div class="col-md-12">
        <div class="row">
          <div class="col-12">
            <div class="mt-5 container">
              <div class="row mb-3">
                <div class="col-md-12">
                  <span class="MM18">Settlement Summary</span>
                  </div>
              </div>
              <table
                class="table table-bordered MM14"
                style="table-layout: fixed"
              >
                <thead>
                  <tr>
                    <th scope="col">Paid Amount</th>
                    <th scope="col">TDS Amount</th>
                    <th scope="col">UTR</th>
                    <th scope="col">Payment Date</th>
                  </tr>
                </thead>
                <tbody>
                 
                  <ng-template
                    [ngIf]="
                      data.claimDetails?.listOfPaymentDetails
                    "
                  >
                    <tr
                      *ngFor="
                        let item of data.claimDetails?.listOfPaymentDetails;
                        let i = index
                      "
                    >
                      <td style="text-align: right"
                      class="text-right">{{ item.amount  | currency: "INR":"symbol":"1.0-0"}}</td>
                      <td style="text-align: right"
                      class="text-right">{{ item.tdsAmount  | currency: "INR":"symbol":"1.0-0"}}</td>
                      <td>{{ item.utrNumber }}</td>
                      <td>{{ item.dateOfPayment | date}}</td>
                    </tr>
                  </ng-template>                 
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    
    </div>
  </ng-template> 
  </ng-template>
  <ng-template [ngIf]="data.statusType === 'ENHANCEMENT_APPROVAL_RECEIVED' || data.statusType === 'APPROVE' || data.statusType === 'SETTLED'">
    <div class="row row_flex" style="min-height: 40vh">
      <div class="col-md-12">
        <div class="row">
          <div class="col-12">
            <div class="mt-5 container">
              <div class="row mb-3">
                <div class="col-md-12">
                  <span class="MM18">Payment Summary</span>
                  <p>
                    Detailed breakup of claim amount calculation will be as per
                    the letter of credit issue by the TPA.
                  </p>
                </div>
              </div>
              <table
                class="table table-bordered MM14"
                style="table-layout: fixed"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th scope="col">Total Claimed</th>
                    <th scope="col">Deductions</th>
                    <th scope="col">Total Approved</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngIf="
                      data.claimDetails.claimAmount?.insurerPaymentSummary
                        ?.preAuthApproval
                    "
                  >
                    <td>Pre Auth Approval</td>
                    <td style="text-align: right">
                      {{
                        data.claimDetails.claimAmount?.insurerPaymentSummary
                          .preAuthApproval.claimedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td
                      style="text-align: right"
                      class="text-right"
                      *ngIf="
                        [
                          'PRE_AUTH_SUBMITTED',
                          'PRE_AUTH_UNDER_REVIEW',
                          'PRE_AUTH_UNDER_QUERY',
                          'PRE_AUTH_QUERY_RESPONDED',
                          'CLAIM_REJECTED'
                        ].indexOf(data.claimDetails.claimStatus) === -1
                      "
                    >
                      {{
                        data.claimDetails.claimAmount?.insurerPaymentSummary
                          .preAuthApproval.deductions
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td
                      style="text-align: right"
                      class="text-right"
                      *ngIf="
                        [
                          'PRE_AUTH_SUBMITTED',
                          'PRE_AUTH_UNDER_REVIEW',
                          'PRE_AUTH_UNDER_QUERY',
                          'PRE_AUTH_QUERY_RESPONDED',
                          'CLAIM_REJECTED'
                        ].indexOf(data.claimDetails.claimStatus) != -1
                      "
                    >
                      {{ zeroAmount | currency: "INR":"symbol":"1.0-0" }}
                    </td>

                    <td
                      style="text-align: right"
                      class="text-right"
                      *ngIf="
                        [
                          'PRE_AUTH_SUBMITTED',
                          'PRE_AUTH_UNDER_REVIEW',
                          'PRE_AUTH_UNDER_QUERY',
                          'PRE_AUTH_QUERY_RESPONDED',
                          'CLAIM_REJECTED'
                        ].indexOf(data.claimDetails.claimStatus) === -1
                      "
                    >
                      {{
                        data.claimDetails.claimAmount?.insurerPaymentSummary
                          .preAuthApproval.finalApprovedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td
                      style="text-align: right"
                      class="text-right"
                      class="text-right"
                      *ngIf="
                        [
                          'PRE_AUTH_SUBMITTED',
                          'PRE_AUTH_UNDER_REVIEW',
                          'PRE_AUTH_UNDER_QUERY',
                          'PRE_AUTH_QUERY_RESPONDED',
                          'CLAIM_REJECTED'
                        ].indexOf(data.claimDetails.claimStatus) != -1
                      "
                    >
                      {{ zeroAmount | currency: "INR":"symbol":"1.0-0" }}
                    </td>
                  </tr>
                  <ng-template
                    [ngIf]="
                      data.claimDetails?.claimAmount?.insurerPaymentSummary
                        ?.enhancementApprovals
                    "
                  >
                    <tr
                      *ngFor="
                        let item of data.claimDetails?.claimAmount
                          ?.insurerPaymentSummary?.enhancementApprovals;
                        let i = index
                      "
                    >
                      <td>Enhancement {{ i + 1 }}</td>
                      <td style="text-align: right">
                        {{
                          item.claimedAmount | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>
                      <td style="text-align: right">
                        {{ item.deductions | currency: "INR":"symbol":"1.0-0" }}
                      </td>

                      <td style="text-align: right">
                        {{
                          item.finalApprovedAmount
                            | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>
                    </tr>
                  </ng-template>
                  <tr
                    *ngIf="
                      data.claimDetails?.claimAmount?.insurerPaymentSummary
                        ?.finalApproval
                    "
                  >
                    <td>Final Approval</td>

                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.finalApproval.claimedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.finalApproval.deductions
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>

                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.finalApproval.finalApprovedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      data.claimDetails?.claimAmount?.insurerPaymentSummary
                        ?.revisedFinalApproval
                    "
                  >
                    <td>Revised Final Approval</td>
                    <ng-template
                      [ngIf]="
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.revisedFinalApproval
                      "
                    >
                      <td style="text-align: right">
                        {{
                          data.claimDetails?.claimAmount?.insurerPaymentSummary
                            ?.revisedFinalApproval.claimedAmount
                            | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>
                      <td style="text-align: right">
                        {{
                          data.claimDetails?.claimAmount?.insurerPaymentSummary
                            ?.revisedFinalApproval.deductions
                            | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>

                      <td style="text-align: right">
                        {{
                          data.claimDetails?.claimAmount?.insurerPaymentSummary
                            ?.revisedFinalApproval.finalApprovedAmount
                            | currency: "INR":"symbol":"1.0-0"
                        }}
                      </td>
                    </ng-template>
                  </tr>
                  <tr
                    *ngIf="
                      data.claimDetails?.claimAmount?.insurerPaymentSummary
                        ?.reimbursementApproval
                    "
                  >
                    <td>Reimbursement Approval</td>
                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.reimbursementApproval.claimedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.reimbursementApproval.deductions
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>

                    <td style="text-align: right">
                      {{
                        data.claimDetails?.claimAmount?.insurerPaymentSummary
                          ?.reimbursementApproval.finalApprovedAmount
                          | currency: "INR":"symbol":"1.0-0"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    
    </div>
  </ng-template>
  <mat-dialog-actions align="end">
    <div class="row row-flex">
      <div class="col-md-12 mb-5">
        <button
          mat-stroked-button
          color="primary"
          (click)="submitClick()"
          class="buttonSmallPrimaryBlue"
        >
          Submit
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>
